import styled from 'styled-components';
import { select } from '@panel/commons/core/themev2';
import ChevronDownGray from '../../assets/icons/ChevronDownGray.svg';

const ContainerDropdown = styled.div`
  position: relative;
  width: ${({ width, device }) => (device === 'mobile' ? '100%' : width)};
`;

const CollapsedDropdown = styled.div`
  width: ${({ width, device }) => (device === 'mobile' ? '100%' : width)};
  height: ${({ height }) => height};
  font-family: 'Hind';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 130%;
  color: ${select('grayDarkLight')};
  padding: 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
`;

const ElementBox = styled.div`
  margin: ${({ device }) => (device === 'mobile' ? '0' : '5px 3px 0 6px')};
  overflow: hidden;
  text-overflow: ellipsis;
`;

const TextSelected = styled.div`
  text-align: start;
`;

const Chevron = styled.button`
  width: ${({ device }) => (device === 'mobile' ? '23px' : '18px')};
  height: ${({ device }) => (device === 'mobile' ? '23px' : '18px')};
  background-image: ${`url(${ChevronDownGray})`};
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  position: relative;
  opacity: 1;
  transform: ${({ active }) => `rotateX(${active ? '180deg' : '0deg'})`};
  transition: all 0.4s ease;
  cursor: pointer;
  margin: 2px 6px 0 0;
`;

const OpenDropdown = styled.div`
  width: ${({ width, device }) => (device === 'mobile' ? '100%' : width)};
  max-height: ${({ device }) => (device === 'mobile' ? '430px' : '600px')};
  overflow-y: auto;
  ::-webkit-scrollbar {
    -webkit-appearance: none;
  }
  ::-webkit-scrollbar:vertical {
    background-color: ${select('LightGray')};
    width: 10px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 32px;
    border: 9px solid ${select('midLightGray')};
    z-index: 2;
  }
  ::-webkit-scrollbar-track {
    background-color: ${select('lightGray')};
    border-radius: 32px;
  }
  position: absolute;
  top: 24px;
  right: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  margin-top: 8px;
  padding-top: 10px;
  border-radius: 6px;
  border: 1px solid ${select('midDarkGray')};
  background-color: ${select('white')};
  visibility: ${({ active }) => (active ? 'visible' : 'hidden')};
  opacity: ${({ active }) => (active ? 1 : 0)};
  transition: opacity 0.4s ease;
  z-index: 3;
`;

const ListItems = styled.div`
  height: 40px;
  padding: 10px 12px 0 14px;
  font-family: 'Hind';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  :hover {
    font-weight: 600;
    line-height: 130%;
    background-color: ${select('lightGray')};
  }
`;

export { ContainerDropdown, CollapsedDropdown, ElementBox, TextSelected, Chevron, OpenDropdown, ListItems };
